import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function RichTextEditor({ label, onChange, value }: any) {
  return (
    <>
      <div>{label}</div>
      <CKEditor
        data={value || ""}
        onChange={(_e: any, editor: any) => {
          const data = editor.getData();
          onChange(data);
        }}
        editor={ClassicEditor as any}
        config={{
          heading: {
            options: [
              {
                model: "paragraph",
                title: "Paragraph",
                class: "ck-heading_paragraph",
              },
              {
                model: "heading1",
                view: "h1",
                title: "Heading 1",
                class: "ck-heading_heading1",
              },
              {
                model: "heading2",
                view: "h2",
                title: "Heading 2",
                class: "ck-heading_heading2",
              },
              {
                model: "heading3",
                view: "h3",
                title: "Heading 3",
                class: "ck-heading_heading3",
              },
            ],
          },
        }}
      />
    </>
  );
}

export default RichTextEditor;
